export enum IntegrationTypes {
    LANCET = 'lancet',
    I_CAN_SCRIPT = 'i_can_script',
    CLICK_DOC = 'click_doc',
    PATH_CARE_VERMAAK = 'path_care_vermaak',
    XERO = 'xero',
    MESSAGING = 'messaging',
    JARGON = 'jargon',
    EMGUIDANCE_SCRIPT = 'emguidance_script'
}